(() => {
  const inputSelector = '.swinger-searchform > .swinger-input > .swinger-input__input';

  window.swinger.eventHub.register('reset', '.swinger-searchform', (e) => {
    const form = window.swinger.eventHub.getTarget(e);
    const input = window.swinger.$('.swinger-input__input', form)[0];

    window.swinger.eventHub.trigger(input, 'change');

    input.focus();
  });

  window.swinger.eventHub.register('keydown', inputSelector, (e) => {
    const input = window.swinger.eventHub.getTarget(e);

    switch (e.key) {
      default:
        input.setAttribute('aria-activedescendant', '');
        break;

      case 'Up':
      case 'ArrowUp':
      case 'Down':
      case 'ArrowDown':
      case 'Enter':
        return;

      case 'Escape':
      case 'Esc':
        if (input.value) {
          e.preventDefault();
        } else {
          document.querySelector('.swinger-header__metanav-item-link[for="search"]').focus();
        }
        input.value = '';
        window.swinger.eventHub.trigger(input, 'change');
        input.setAttribute('aria-activedescendant', '');
        break;
    }
  });

  window.swinger.eventHub.register('focus', inputSelector, (e) => {
    const input = window.swinger.eventHub.getTarget(e);

    if (!input.value) {
      return;
    }

    window.swinger.eventHub.trigger(input, 'change');
  });

  window.swinger.observer.initialize(inputSelector, (elem) => {
    elem.setAttribute('role', 'combobox');
    elem.setAttribute('aria-activedescendant', '');
    elem.setAttribute('aria-autocomplete', 'list');
    elem.setAttribute('aria-controls', 'swinger-autocomplete');
    elem.setAttribute('aria-expanded', 'false');
    elem.setAttribute('aria-haspopup', 'listbox');

    if (elem.value) {
      const wrapper = elem.closest('.swinger-input');
      wrapper.classList.add('swinger-input--is-filled');
    }
  }, false);

  /* The following allows for cursor navigation in between all currently visible menu items */
  window.swinger.navigationHelper.enableArrowNav('.swinger-searchform');
})();
